import { __exportAll } from "../../_virtual/_rolldown/runtime.js";

//#region src/types/plugins/ContainerPlugin.ts
var ContainerPlugin_exports = /* @__PURE__ */ __exportAll({});

//#endregion
export { ContainerPlugin_exports };
//# sourceMappingURL=ContainerPlugin.js.map